import { getCarouselNavButtonClassName, getCarouselNavIconClassName } from './carousel-nav-button.styles';
import { CarouselNavButtonVariant } from './carousel-nav-buttons-props.interface';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import React from 'react';

interface CarouselNavButtonItemProps {
  direction: 'left' | 'right';
  disabled?: boolean;
  ariaLabel: string;
  onClick: () => void;
  variant?: CarouselNavButtonVariant;
  className?: string;
}

const CarouselNavButtonItem: React.FC<CarouselNavButtonItemProps> = ({
  direction,
  disabled = false,
  ariaLabel,
  onClick,
  variant = 'bolder',
  className,
}) => {
  const Icon = direction === 'left' ? ChevronLeft : ChevronRight;

  return (
    <button
      type="button"
      disabled={disabled}
      aria-label={ariaLabel}
      className={getCarouselNavButtonClassName({ variant, disabled, className })}
      onClick={onClick}
    >
      <Icon className={getCarouselNavIconClassName(variant)} />
    </button>
  );
};

export default CarouselNavButtonItem;
